var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"must-label"},[(_vm.isMust)?_c('p',{staticClass:"must-label-icon"},[_vm._v("*")]):_vm._e(),_c('p',{staticClass:"must-label-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }